import React, { Component } from 'react';
import Configuration from './Configuration';
import Validators from '../../../../common/utils/Validators';
import {
  saveInstrumentConfiguration,
  updateInstrumentConfiguration,
  getInstrumentConfiguration,
} from './Configuration.actions';
import Constants from '../../../../common/constants/Constants';
import Store from '../../../../redux/Store';
import { showSnackbar } from '../../../../common/state/snackbar/Snackbar.actions';

class ConfigurationContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      InstrumentConfig: {
        InstrumentId: props.instrument.InstrumentId,
        Latitude: props.instrument.Latitude,
        Longitude: props.instrument.Longitude,
        InstrumentSerialNumber: props.instrument.SerialNumber,
        Metadata: props.instrument.Metadata,
        Location: props.instrument.Location,
        Enabled: props.instrument.Enabled,
        Deprovisioned: props.instrument.Deprovisioned,
        Stale: true,
      },
      messageToConfirmForChangingConnection: '',
      showDisableConnectionConfirmDialog: {
        show: false,
        action: () => {},
        cancel: () => {},
        disableMainAction: false,
      },
      errorMessageLatitude: '',
      errorMessageLongitude: '',
      errorMessageLocation: '',
      onSaveCallback: () => {},
      onRemoveCoordinatesCallback: () => {},
      showRemoveCoordinatesConfirmDialog: {
        show: false,
        action: () => {},
        cancel: () => {},
        disableMainAction: false,
      },
      messageToConfirmForRemovingCoordinates: '',
      onRemoveLcationCallback: () => {},
      showRemoveLocationConfirmDialog: {
        show: false,
        action: () => {},
        cancel: () => {},
        disableMainAction: false,
      },
      messageToConfirmForRemovingLocation: '',
    };
  }

  componentDidMount() {
    getInstrumentConfiguration(this.props.instrument.InstrumentId).then((res) => {
      this.setState({
        InstrumentConfig: res.body,
      });
    });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.instrument.SerialNumber != this.props.instrument.SerialNumber) {
      getInstrumentConfiguration(this.props.instrument.InstrumentId).then((res) => {
        this.setState({
          InstrumentConfig: res.body,
        });
      });
    }
  }

  render() {
    return (
      <Configuration
        InstrumentConfig={this.state.InstrumentConfig}
        showDisableConnectionConfirmDialog={this.state.showDisableConnectionConfirmDialog}
        messageToConfirmForChangingConnection={this.state.messageToConfirmForChangingConnection}
        onChangeCallback={this._onChange}
        errorMessageLatitude={this.state.errorMessageLatitude}
        errorMessageLongitude={this.state.errorMessageLongitude}
        errorMessageLocation={this.state.errorMessageLocation}
        onBlockUnblockConnectionCallback={this._onChangeConnectionHandler}
        onDeprovisionCallback={this._onDeprovision}
        onSaveCallback={this._onSave}
        onRemoveCoordinatesCallback={this._onRemoveCoordinatesCallback}
        showRemoveCoordinatesConfirmDialog={this.state.showRemoveCoordinatesConfirmDialog}
        messageToConfirmForRemovingCoordinates={this.state.messageToConfirmForRemovingCoordinates}
        onRemoveLocationCallback={this._onRemoveLocationCallback}
        showRemoveLocationConfirmDialog={this.state.showRemoveLocationConfirmDialog}
        messageToConfirmForRemovingLocation={this.state.messageToConfirmForRemovingLocation}
      />
    );
  }

  _onChange = (propertyName, value) => {
    let newInstrumentConfig = {
      ...Object.assign({}, this.state.InstrumentConfig),
      [propertyName]: value,
    };

    this.setState((prevState) => ({
      InstrumentConfig: newInstrumentConfig,
      errorMessageLatitude:
        prevState.InstrumentConfig.Latitude !== newInstrumentConfig.Latitude
          ? this.getValidationErrorMessage(propertyName, value)
          : prevState.errorMessageLatitude,
      errorMessageLongitude:
        prevState.InstrumentConfig.Longitude !== newInstrumentConfig.Longitude
          ? this.getValidationErrorMessage(propertyName, value)
          : prevState.errorMessageLongitude,
      errorMessageLocation:
        prevState.InstrumentConfig.Location !== newInstrumentConfig.Location
          ? this.getValidationErrorMessage(propertyName, value)
          : prevState.errorMessageLocation,
    }));
  };

  _onSave = () => {
    let instrumentConfigToSave = this.state.InstrumentConfig;

    if (this.state.InstrumentConfig.InstrumentId) {
      updateInstrumentConfiguration(instrumentConfigToSave).then((res) =>
        this.processResponse(
          res,
          'Successfully updated. It may take a few minutes for the setting to apply.',
          'Failed updating configuration'
        )
      );
    } else {
      saveInstrumentConfiguration(instrumentConfigToSave).then((res) =>
        this.processResponse(
          res,
          'Successfully saved. It may take a few minutes for the setting to apply.',
          'Failed saving configuration'
        )
      );
    }
  };

  _onRemoveCoordinatesCallback = () => {
    if (
      this.state.InstrumentConfig.Latitude != null &&
      this.state.InstrumentConfig.Longitude != null
    ) {
      this.setState({
        messageToConfirmForRemovingCoordinates: `Are you sure you want to remove coordinates Latitude: "${this.state.InstrumentConfig.Latitude}" and Longitude: "${this.state.InstrumentConfig.Longitude}" from instrument "${this.state.InstrumentConfig.InstrumentSerialNumber}"?`,
        showRemoveCoordinatesConfirmDialog: {
          title: `Remove coordinates `,
          show: true,
          action: () => this._onConfirmRemoveCoordinates(),
          cancel: this._onCancelRemoveCoordinates,
          mainActionLabel: 'Yes',
        },
      });
    } else {
      this.showFailMessage('No coordinates to remove. ');
    }
  };

  _onConfirmRemoveCoordinates = () => {
    let newInstrumentConfig = {
      ...Object.assign({}, this.state.InstrumentConfig),
    };
    newInstrumentConfig.Latitude = null;
    newInstrumentConfig.Longitude = null;

    updateInstrumentConfiguration(newInstrumentConfig)
      .then(getInstrumentConfiguration(newInstrumentConfig.InstrumentId))
      .then((res) => {
        if (res.body) {
          this.setState({
            InstrumentConfig: res.body,
            messageToConfirmForRemovingCoordinates: '',
            showRemoveCoordinatesConfirmDialog: {
              show: false,
              disableMainAction: false,
              action: () => {},
              cancel: () => {},
            },
            errorMessageLatitude: '',
            errorMessageLongitude: '',
          });
        }
        this.showSuccesMessage(
          'Successfully removed. It may take a few minutes for the setting to apply.'
        );
      })
      .catch((err) => this.showFailMessage('Could not remove coordinates. '));
  };

  _onCancelRemoveCoordinates = () => {
    this.setState({
      messageToConfirmForRemovingCoordinates: '',
      showRemoveCoordinatesConfirmDialog: {
        show: false,
        action: () => {},
        cancel: () => {},
        disableMainAction: false,
      },
    });
  };

  _onRemoveLocationCallback = () => {
    if (this.state.InstrumentConfig.Location != null) {
      this.setState({
        messageToConfirmForRemovingLocation: `Are you sure you want to remove location "${this.state.InstrumentConfig.Location}" from instrument "${this.state.InstrumentConfig.InstrumentSerialNumber}"?`,
        showRemoveLocationConfirmDialog: {
          title: `Remove location `,
          show: true,
          action: () => this._onConfirmRemoveLocation(),
          cancel: this._onCancelRemoveLocation,
          mainActionLabel: 'Yes',
        },
      });
    } else {
      this.showFailMessage('No location to remove. ');
    }
  };

  _onConfirmRemoveLocation = () => {
    let newInstrumentConfig = {
      ...Object.assign({}, this.state.InstrumentConfig),
    };
    newInstrumentConfig.Location = null;

    updateInstrumentConfiguration(newInstrumentConfig)
      .then(getInstrumentConfiguration(newInstrumentConfig.InstrumentId))
      .then((res) => {
        if (res.body) {
          this.setState({
            InstrumentConfig: res.body,
            messageToConfirmForRemovingLocation: '',
            showRemoveLocationConfirmDialog: {
              show: false,
              disableMainAction: false,
              action: () => {},
              cancel: () => {},
            },
            errorMessageLocation: '',
          });
        }
        this.showSuccesMessage(
          'Successfully removed. It may take a few minutes for the setting to apply.'
        );
      })
      .catch((err) => this.showFailMessage('Could not remove coordinates. '));
  };

  _onCancelRemoveLocation = () => {
    this.setState({
      messageToConfirmForRemovingLocation: '',
      showRemoveLocationConfirmDialog: {
        show: false,
        action: () => {},
        cancel: () => {},
        disableMainAction: false,
      },
    });
  };

  _onChangeConnection = (enabled) => {
    let newInstrumentConfig = {
      ...Object.assign({}, this.state.InstrumentConfig),
      Enabled: enabled,
    };

    updateInstrumentConfiguration(newInstrumentConfig)
      .then((res) =>
        this.processResponse(
          res,
          'Successfully updated. It may take a few minutes for the setting to apply.',
          'Failed updating configuration'
        )
      )
      .catch((res) => {
        this.setState({
          showDisableConnectionConfirmDialog: {
            show: false,
            disableMainAction: false,
            action: () => {},
            cancel: () => {},
          },
        });
        this.showFailMessage('Server error.');
      });
  };

  _onChangeProvisioning = (deprovisioned) => {
    let newInstrumentConfig = {
      ...Object.assign({}, this.state.InstrumentConfig),
      Deprovisioned: deprovisioned,
    };
    updateInstrumentConfiguration(newInstrumentConfig)
      .then((res) =>
        this.processResponse(
          res,
          'Successfully updated. It may take a few minutes for the setting to apply.',
          'Failed updating configuration',
          'deprovisioning'
        )
      )
      .catch((res) => {
        this.setState({
          showDisableConnectionConfirmDialog: {
            show: false,
            disableMainAction: false,
            action: () => {},
            cancel: () => {},
          },
        });
        this.showFailMessage('Server error.');
      });
  };

  _onChangeConnectionHandler = (enableConnection) => {
    if (enableConnection) {
      this._onEnableConnection();
    } else {
      this._onDisableConnection();
    }
  };

  _onDeprovision = () => {
    this.setState({
      messageToConfirmForChangingConnection:
        'Are you sure that you want to deprovision the current certificate?',
      showDisableConnectionConfirmDialog: {
        title:
          'Warning! Once an instrument has been deprovisioned, it can only connect again after a new certificate has been requested on site.',
        show: true,
        action: () => this._onChangeProvisioning(true),
        cancel: this._onCancelChangeConnection,
        mainActionLabel: 'Yes',
      },
    });
  };

  _onCancelChangeConnection = () => {
    this.setState({
      showDisableConnectionConfirmDialog: {
        show: false,
        action: () => {},
        cancel: () => {},
      },
    });
  };

  _onDisableConnection = () => {
    this.setState({
      messageToConfirmForChangingConnection:
        "Are you sure you want to change instrument's connection?",
      showDisableConnectionConfirmDialog: {
        title: 'Warning! This will block the instrument communication with the Cloud',
        show: true,
        action: () => this._onChangeConnection(false),
        cancel: this._onCancelChangeConnection,
        mainActionLabel: 'Yes',
      },
    });
  };

  _onEnableConnection = () => {
    this.setState({
      messageToConfirmForChangingConnection:
        "Are you sure you want to change instrument's connection?",
      showDisableConnectionConfirmDialog: {
        title: 'Warning! This will unblock the instrument communication with the Cloud',
        show: true,
        action: () => this._onChangeConnection(true),
        cancel: this._onCancelChangeConnection,
        mainActionLabel: 'Yes',
      },
    });
  };

  processResponse(res, messageSuccess, messageFail, requestType) {
    let newInstrumentConfig = {};
    if (res.body) {
      newInstrumentConfig = res.body;
      this.setState({
        InstrumentConfig: newInstrumentConfig,
        showDisableConnectionConfirmDialog: {
          show: false,
          disableMainAction: false,
          action: () => {},
          cancel: () => {},
        },
      });
      if (requestType === 'deprovisioning' && newInstrumentConfig.Deprovisioned == false) {
        this.showFailMessage(
          'This instrument does not use certificates or has not been connected yet using a certificate and cannot be deprovisioned.'
        );
        return;
      }
      this.showSuccesMessage(messageSuccess);
    } else {
      this.showFailMessage(messageFail);
    }
  }

  showSuccesMessage(theMessage) {
    Store.dispatch(
      showSnackbar({
        type: Constants.SNACKBAR_MESSAGE_TYPES.SUCCESS,
        message: theMessage,
      })
    );
  }

  showFailMessage(theMessage) {
    Store.dispatch(
      showSnackbar({
        type: Constants.SNACKBAR_MESSAGE_TYPES.ERROR,
        message: theMessage,
      })
    );
  }

  getValidationErrorMessage = (propertyName, value) => {
    let validationMessage = '';

    switch (propertyName) {
      case 'Latitude': {
        if (!Validators.validateLatitude(value)) {
          validationMessage = 'Enter a value between -90 and 90; for example 40.13';
        }
        return validationMessage;
      }
      case 'Longitude': {
        if (!Validators.validateLongitude(value)) {
          validationMessage = 'Enter a value between -180 and 180; for example 10.15';
        }
        return validationMessage;
      }
      case 'Location': {
        if (!Validators.validateStringBetweenRange(value, 1, 200)) {
          validationMessage = 'Enter an alphanumeric value between 1 and 200 characters';
        }
        return validationMessage;
      }
      default:
        return validationMessage;
    }
  };
}

export default ConfigurationContainer;
